import styled from '@emotion/styled'
import React, { createRef, useEffect } from 'react'

import { useCommonStore } from '~/states/commonStore'

const src = 'https://utteranc.es/client.js'
const repo = '1000peach/blog-comments'

type UtterancesAttributes = {
  src: string
  repo: string
  'issue-term': string
  label: string
  theme: string
  crossorigin: string
  async: string
}

const CommentWidget: React.FC = () => {
  const { isLightMode } = useCommonStore()
  const element = createRef<HTMLDivElement>()

  useEffect(() => {
    if (element.current === null) {
      return
    }

    const utterances: HTMLScriptElement = document.createElement('script')

    const attributes: UtterancesAttributes = {
      src,
      repo,
      'issue-term': 'pathname',
      label: 'Comment',
      theme: isLightMode ? 'github-light' : 'dark-blue',
      crossorigin: 'anonymous',
      async: 'true',
    }

    Object.entries(attributes).forEach(([key, value]) => {
      utterances.setAttribute(key, value)
    })

    // TODO: 다크모드 리렌더링 방법 변경
    element.current.replaceChildren()
    element.current.appendChild(utterances)
  }, [isLightMode])

  return <Wrapper ref={element} />
}

const Wrapper = styled.div`
  padding: 30px 0;

  @media ${({ theme: { device } }) => device.mobile} {
    padding: 0;
  }
`

export default CommentWidget
